module.exports = __webpack_public_path__ + "Roboto-BoldItalic.d23d5bdadc495f12ef69.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-BoldItalic.ttf
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-BoldItalic.ttf
// module chunks = styles